module.exports = __webpack_public_path__ + "img/invoice-excel-green.2ec46d5f.svg";